<template>
  <div class="forget-password_modal_box">
    <a-modal
      v-model:visible="visible"
      title="重置密码"
      centered
      :footer="null"
      :maskClosable="false"
      forceRender
      @cancel="cancel">
      <a-form
        name="forgetPasswordName"
        ref="forgetPasswordFormRef"
        :model="forgetPasswordForm"
        :rules="forgetPasswordRulesData">
        <a-form-item label="" name="phoneNumber">
          <a-input
            v-model:value="forgetPasswordForm.phoneNumber"
            size="large"
            :maxlength="11"
            placeholder="请输入手机号" />
        </a-form-item>
        <a-form-item label="" name="captcha">
          <div class="dis_ajc">
            <a-input-search
              v-model:value="forgetPasswordForm.captcha"
              placeholder="请输入验证码"
              size="large"
              :maxlength="8"
              @search="onSend">
              <template #enterButton>
                <a-button
                  style="width: 136px"
                  type="primary"
                  size="large"
                  :disabled="codeData.state"
                  :loading="codeData.loading"
                  >{{ codeData.txt }}</a-button
                >
              </template>
            </a-input-search>
          </div>
        </a-form-item>
        <a-form-item label="" name="password">
          <a-input-password
            v-model:value="forgetPasswordForm.password"
            size="large"
            :maxlength="20"
            placeholder="请输入新的登录密码" />
        </a-form-item>
        <a-form-item label="" name="confirmPassword">
          <a-input-password
            v-model:value="forgetPasswordForm.confirmPassword"
            size="large"
            :maxlength="20"
            placeholder="请再次输入新的登录密码" />
        </a-form-item>
      </a-form>
      <div class="form_btn">
        <a-button class="btn" size="large" @click="cancel">取消</a-button>
        <a-button
          class="btn"
          type="primary"
          size="large"
          :loading="btn_loading"
          @click="sureForm"
          >确定</a-button
        >
      </div>
    </a-modal>
  </div>
</template>

<script setup name="forget-password">
import { sendSmsCaptcha, resetPassword } from "@/api/validation.js";
import { ref, reactive, onMounted, defineExpose } from "vue";
import { message } from "ant-design-vue";
import { getRsa } from "@/utils/function.js";
const visible = ref(false);
const btn_loading = ref(false);
const forgetPasswordFormRef = ref(null);
const forgetPasswordForm = ref({});
// 表单校验
const forgetPasswordRulesData = ref({
  phoneNumber: [
    {
      validator: (rule, value, callback) => {
        let length = value?.trim().length || 0;
        if (length == 11) {
          const phoneReg = /^1[3,4,5,6,7,8,9][0-9]{9}$/; // 手机号正则
          if (phoneReg.test(value.trim())) {
            return Promise.resolve();
          } else {
            return Promise.reject("请输入正确的手机号");
          }
        } else {
          let str = length == 0 ? "请输入手机号" : "请输入正确的手机号";
          return Promise.reject(str);
        }
      },
      trigger: ["change", "blur"],
    },
  ],
  captcha: [{ required: true, message: "请输入验证码" }],
  password: [
    {
      validator: (rule, value, callback) => {
        let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)([a-zA-Z0-9]){8,16}$/;
        // 含大小写字符和数字。长度8-16位
        if (!value) {
          callback("请输入新的登录密码");
        } else if (regex.test(value)) {
          callback();
        } else {
          callback("密码长度8-16位，包含大小写英文和数字");
        }
      },
      trigger: ["change", "blur"],
    },
  ],
  confirmPassword: [
    {
      validator: (rule, value, callback) => {
        if (forgetPasswordForm.value.password === value) {
          callback();
        } else if (value === "") {
          callback("请再次输入新的登录密码");
        } else {
          callback("两次密码不一致");
        }
      },
      trigger: ["change", "blur"],
    },
  ],
});
// 发送验证码--按钮
const codeData = reactive({
  state: false,
  loading: false,
  txt: "发送验证码", // 60s后重新获取
});
// 获取验证码
const onSend = () => {
  forgetPasswordFormRef.value
    .validateFields(["phoneNumber"])
    .then(async () => {
      let phone = forgetPasswordForm.value.phoneNumber;
      codeData.loading = true;
      try {
        let res = await sendSmsCaptcha({ phoneNumber: phone });
        codeData.loading = false;
        txtChange();
      } catch (error) {
        codeData.loading = false;
      }
    })
    .catch((err) => {
    });
};
// 关闭弹窗
const cancel = async () => {
  await forgetPasswordFormRef.value.resetFields();
  visible.value = false;
};

const sureForm = async () => {
  await forgetPasswordFormRef.value.validate();
  let { phoneNumber, captcha, password, confirmPassword } =
    forgetPasswordForm.value;
  let params = {
    phoneNumber: await getRsa(phoneNumber),
    captcha: captcha,
    password: await getRsa(password),
    confirmPassword: confirmPassword,
  };
  await resetPassword(params);
  message.success({ content: "重置密码成功", duration: 3 });
  cancel();
};

// 发送按钮 变化
function txtChange(i = 60) {
  codeData.state = true;
  codeData.txt = i + "s后重新获取";
  let timeObj = setInterval(() => {
    i--;
    if (i <= 0) {
      codeData.txt = "发送验证码";
      codeData.state = false;
      clearInterval(timeObj);
    } else {
      codeData.txt = i + "s后重新获取";
    }
  }, 1000);
}

defineExpose({
  visible,
});
</script>

<style lang="scss" scoped>
.form_btn {
  display: flex;
  justify-content: space-between;
  .btn {
    width: 45%;
  }
}
</style>
